import { gql } from '@apollo/client';

export const CREATE_PUSH = gql`
  mutation CreatePush($data: PushCreationInput!) {
    createPush(data: $data) {
      id
      title
      body
      targetDevice
      article {
        id
      }
      userId
      user {
        id
        name
      }
      scheduledAt
      isCancelled
      sentAt
      segments(first: 100) {
        segment {
          title
        }
      }
    }
  }
`;
